/**
 * O `X-Request-Id` da última resposta que o console recebeu.
 *
 * Serve ao card de erro de rota: quando uma tela quebra no render, o defeito não
 * é de uma requisição — é do dado que uma delas trouxe. Sem um identificador, o
 * relato vira "a tela de X quebrou" e ninguém acha a linha no log do backend;
 * com ele, a busca é direta.
 *
 * É deliberadamente **a última**, não "a que falhou": quem quebra o render é
 * quase sempre uma resposta **200** com forma inesperada — foi assim que
 * `identity-roles` devolvendo `{itens:[…]}` onde o contrato promete um array
 * derrubou a tela de Identidades inteira.
 */

let last: string | null = null;

export function recordRequestID(id: string | null | undefined): void {
  if (id) last = id;
}

export function lastRequestID(): string | null {
  return last;
}
